export const version = "json-wallets/5.4.0";
//# sourceMappingURL=_version.js.map